module.exports = __webpack_public_path__ + "img/green-3-mb.ad9aef24.png";